export const MailLink = ({ invoiceId, hotelName }) => {
  const subject = encodeURI(`Regarding statement #${invoiceId} from ${hotelName}`)

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`mailto:billing@directful.com?subject=${subject}`}
    >
      billing@directful.com
    </a>
  )
}
